export default {
  // General
  app_name: 'mvplan',
  calculate: 'Oblicz dekompresję',
  save: 'Zapisz',
  cancel: 'Anuluj',
  add: 'Dodaj',
  edit: 'Edytuj',
  delete: 'Usuń',
  reset: 'Resetuj',
  confirm_reset: 'Zresetować wszystkie ustawienia?',
  confirm_delete: 'Usunąć ten element?',

  // Navigation
  nav_plan: 'Plan',
  nav_gases: 'Gazy',
  nav_profile: 'Profil',
  nav_settings: 'Ustawienia',
  nav_day: 'Dzień',

  // Dzień nurkowy
  day_title: 'Dzień nurkowy',
  day_empty: 'W tym dniu nie ma jeszcze żadnego nurkowania.',
  day_empty_hint: 'Dodaj nurkowanie z ekranu Plan, aby rozpocząć serię.',
  day_add_current: 'Dodaj bieżące nurkowanie',
  day_add_needs_segments: 'Ekran Plan nie zawiera żadnego segmentu: nie ma czego dodać.',
  day_ask_surface_interval: 'Przerwa powierzchniowa przed tym nurkowaniem, w minutach:',
  day_invalid_surface_interval: 'Podaj przerwę powierzchniową równą 0 min lub dłuższą.',
  day_surface_interval: 'Przerwa powierzchniowa',
  day_dive_label_placeholder: 'Nazwa nurkowania (opcjonalnie)',
  day_calculate: 'Przelicz dzień',
  day_clear: 'Wyczyść dzień',
  day_confirm_clear: 'Usunąć wszystkie nurkowania z tego dnia?',
  day_remove_dive: 'Usuń to nurkowanie',
  day_confirm_remove: 'Kolejne nurkowania są powiązane z tym i będą wymagały ponownego przeliczenia.',
  day_dive_not_computed: 'Jeszcze nie przeliczone',
  day_dive_stale: 'Przeliczone przed zmianą: ten plan nie opisuje już serii.',
  day_dive_refused: 'Nurkowanie odrzucone, sprawdź wcześniejsze nurkowania serii.',
  day_dives_refused: 'Nie udało się zaplanować wszystkich nurkowań, liczba odrzuconych: {count}. Kolejne są powiązane z nurkowaniem, które nie istnieje.',
  day_summary: 'Suma dnia',
  day_dives_count: 'Nurkowania',
  day_summary_partial: 'Sumy obejmują {computed} przeliczone nurkowania z {total}.',
  day_editing_dive: 'Edytujesz nurkowanie {number} z tego dnia.',
  day_save_into_day: 'Zapisz w dniu',
  day_detach: 'Odłącz',
  day_dive_number: 'Nurkowanie {number} z {total}',
  day_first_dive: 'Pierwsze nurkowanie dnia',
  day_nothing_to_export: 'Żadne nurkowanie tego dnia nie zostało przeliczone: nie ma czego wyeksportować.',
  day_export_failed: 'Nie udało się utworzyć dokumentu. Spróbuj ponownie i sprawdź konsolę przeglądarki.',

  // Saved days
  saved_days_title: 'Zapisane dni',
  saved_days_save: 'Zapisz dzień',
  saved_days_saved: 'Dzień zapisany',
  saved_days_save_failed: 'Nie udało się zapisać tego dnia: nie zawiera żadnego nurkowania albo pamięć jest pełna.',
  saved_days_name_placeholder: 'np. Port-Cros, sobota',
  saved_days_empty: 'Nie zapisano jeszcze żadnego dnia.',
  saved_days_empty_hint: 'Ułóż dzień nurkowy, a następnie zapisz go, aby znaleźć go tutaj.',
  saved_days_confirm_delete: 'Usunąć ten dzień?',
  saved_days_import_error: 'Ten plik nie jest dniem nurkowym wyeksportowanym przez mvplan.',

  // Settings
  settings_algorithm: 'Algorytm',
  settings_gf: 'Współczynniki gradientu',
  settings_gf_low: 'GF Dolny',
  settings_gf_high: 'GF Górny',
  settings_rates: 'Prędkości i Przystanki',
  settings_descent: 'Zanurzenie',
  settings_ascent: 'Wynurzenie',
  settings_deco_ascent: 'Między przystankami',
  settings_last_stop_ascent: 'Ostatnie wynurzenie',
  settings_last_stop: 'Ostatni przystanek',
  settings_safety_stop: 'Przystanek bezpieczeństwa bez deko (min, 0 = brak)',
  settings_rmv: 'RMV',
  settings_rmv_bottom: 'Dno',
  settings_rmv_deco: 'Deko / Bailout',
  settings_ccr: 'Tryb CCR',
  settings_setpoint_mode: 'Tryb Setpoint',
  settings_setpoint_fixed: 'Stały',
  settings_setpoint_dynamic: 'Dynamiczny',
  settings_ppo2: 'Limity ppO2',
  settings_ppo2_working: 'Praca',
  settings_ppo2_deco: 'Deko',
  settings_display: 'Wyświetlanie',
  settings_units: 'Jednostki',
  settings_units_metric: 'Metryczne (m, bar)',
  settings_units_imperial: 'Imperialne (ft, psi)',
  settings_theme: 'Motyw',
  settings_theme_dark: 'Ciemny',
  settings_theme_light: 'Jasny',
  settings_language: 'Język',
  settings_divers: 'Nurkowie',
  settings_divers_hint: 'Imiona na PDF (rozdzielone przecinkami)',
  settings_dive_site: 'Miejsce nurkowania',
  settings_dive_site_placeholder: 'np. Blue Hole, Dahab',
  settings_bailout: 'Bailout',
  settings_bail_delay: 'Opóźnienie bailout (min)',
  settings_bail_delay_hint: 'Czas na dnie przed wynurzeniem w bailout',
  settings_rmv_stress: 'RMV Stres',
  settings_stress_until: 'Stres do',
  settings_stress_first_stop: 'Pierwszy przystanek',
  settings_stress_gas_switch: 'Zmiana gazu',
  settings_stress_surface: 'Powierzchnia',
  settings_time_and_gas: 'Czasy i zmiany gazu',
  settings_descent_included: 'Zanurzenie wliczone',
  settings_descent_included_hint: 'Czas zanurzenia jest wliczony w czas segmentu',
  settings_gas_switch_duration: 'Czas zmiany gazu',
  settings_gas_switch_at_stop: 'Zmiana gazu tylko na przystanku deko',
  settings_gas_switch_at_stop_hint: 'Jeśli wyłączone, zmiana gazu następuje gdy MOD na to pozwala (bardziej optymalne)',
  settings_gf_presets: 'Presety GF',
  settings_gf_presets_hint: 'Szybki dostęp w widoku Planu',
  settings_gf_add_preset: 'Dodaj preset',
  settings_gf_preset_name: 'Nazwa',
  settings_gf_custom: 'Niestandardowy',
  settings_environment: 'Środowisko',
  settings_gas_temp: 'Temp. gazu',
  settings_water_type: 'Rodzaj wody',
  settings_water_salt: 'Woda słona',
  settings_water_fresh: 'Woda słodka',
  settings_water_brackish: 'Woda słonawa',
  settings_water_red_sea: 'Morze Czerwone',
  settings_water_custom: 'Własna gęstość',
  settings_water_density: 'Gęstość wody',
  settings_water_density_hint: 'Gęstość wody zmienia rzeczywiste ciśnienie na danej głębokości, a więc i długość przystanków. Wartości odniesienia: 10000 w wodzie słodkiej, 10150 w wodzie słonawej, 10300 w morzu, 10400 w Morzu Czerwonym (10300 odpowiada 1.03 kg/l). Dopuszczalne wartości: od {min} do {max}.',
  settings_altitude: 'Wysokość',
  settings_environment_hint: 'Temp. gazu = temperatura płuc do obliczenia gęstości (~35°C). Wysokość i rodzaj wody zmieniają również obliczenia dekompresji.',
  settings_alerts: 'Alerty bezpieczeństwa',
  settings_alerts_hint: 'Wyłącz alerty dla doświadczonych nurków',
  settings_alerts_narcosis: 'Alerty narkozy (END)',
  settings_alerts_density: 'Alerty gęstości (CO2)',
  settings_alerts_show_density: 'Zawsze pokazuj gęstość gazu',
  settings_ccr_flush: 'Płukania obiegu (CCR)',
  settings_ccr_flush_hint: 'Dodaje edytor płukań do ekranu planu dla nurkowań z rebreatherem.',
  settings_ccr_flush_duration: 'Domyślny czas płukania (min)',
  settings_ccr_o2_flush: 'Zakończenie nurkowania na 100% tlenu',
  settings_ccr_o2_flush_hint: 'Na ustawionej głębokości obieg przechodzi na czysty tlen i pozostaje na nim do powierzchni.',
  settings_ccr_o2_flush_depth: 'Głębokość (m)',
  settings_ccr_o2_flush_time: 'Czas płukania (min)',
  settings_ccr_o2_flush_invalid: 'Nieużyteczna głębokość lub czas.',
  settings_alerts_icd: 'Alerty ICD (ucho wewnętrzne)',
  settings_pdf: 'Eksport PDF',
  settings_pdf_include_profile: 'Dołącz profil nurkowania',
  settings_pdf_include_profile_hint: 'Wyłącz, aby zmieścić na jednej stronie A4',
  settings_school_mode: 'Tryb szkolny',
  settings_school_mode_hint: 'Porównaj presety GF na wykresie profilu',
  settings_chart_scale: 'Skala wykresu',
  settings_school_presets: 'Presety do porównania',
  profile_school_compare: 'Porównanie GF',
  profile_school_tts: 'TTS',
  profile_school_stops: 'Przystanki',

  // Gases
  gases_title: 'Mieszanki gazów',
  gases_bailout: 'Gazy ratunkowe',
  gases_diluents: 'Rozcieńczalniki',
  gases_name: 'Nazwa',
  gases_mod: 'MOD',
  gases_end: 'END',
  gases_ppo2_max: 'ppO2 max',
  gases_use_bailout: 'Użyj jako bailout',
  gases_tank_config: 'Konfiguracja butli',
  gases_volume: 'Objętość (L)',
  gases_pressure: 'Ciśnienie (bar)',
  gases_capacity: 'Pojemność',

  // Plan
  plan_segments: 'Segmenty nurkowania',
  plan_depth: 'Głębokość',
  plan_time: 'Czas',
  plan_runtime: 'Runtime',
  plan_gas: 'Gaz',
  plan_setpoint: 'SP',
  plan_no_segments: 'Brak segmentów. Dodaj jeden.',
  plan_config: 'Konfiguracja',
  plan_ccr: 'Plan CCR',
  plan_bailout: 'Bailout (Najgorszy przypadek)',
  plan_deco: 'Plan dekompresji',
  plan_no_deco: 'Dekompresja nie jest wymagana',
  plan_stops_summary: 'Podsumowanie przystanków',
  duration_hours_minutes: '{h} h {m}',
  duration_hours: '{h} h',
  duration_minutes: '{m} min',
  plan_desat_sea_level: 'Pozostając na poziomie morza, będziesz całkowicie odsycony {time} po wyjściu z wody.',
  plan_desat_altitude: 'Pozostając na wysokości {altitude} m, będziesz całkowicie odsycony {time} po wyjściu z wody.',
  plan_desat_over: 'Pełne odsycenie wymaga ponad {time} po wyjściu z wody.',
  plan_no_fly: 'Lot (DAN)',
  plan_no_fly_minimum: '> {time}',
  plan_no_fly_dan_rule: 'Czas oczekiwania przed lotem, zalecenia konsensusu DAN: przerwa powierzchniowa co najmniej {noStop} po pojedynczym nurkowaniu bezdekompresyjnym; przerwa powierzchniowa co najmniej {multiDay} przy nurkowaniach powtórzeniowych przez kilka dni; znacznie więcej niż {longer} po nurkowaniu z obowiązkową dekompresją lub na mieszaninach heliox i trimix. To nie jest obliczenie odsycenia.',
  plan_no_fly_dan_case_no_stop: 'To nurkowanie należy do pierwszego przypadku: pojedyncze nurkowanie bez przystanku dekompresyjnego.',
  plan_no_fly_dan_case_repetitive: 'To nurkowanie należy do drugiego przypadku: nurkowanie powtórzeniowe.',
  plan_no_fly_dan_case_deco: 'To nurkowanie należy do trzeciego przypadku: obowiązkowa dekompresja. Pokazany czas to minimum, które należy przekroczyć, a nie wartość zalecana.',
  plan_no_fly_dan_case_helium: 'To nurkowanie należy do trzeciego przypadku: mieszanina z helem. Pokazany czas to minimum, które należy przekroczyć, a nie wartość zalecana.',
  plan_no_fly_dan_source: 'Źródło: DAN, Guidelines for Flying After Diving, konsensus Flying After Recreational Diving Workshop (2002). Badania prowadzono w suchej komorze na ochotnikach w spoczynku: dla nurków zanurzonych i wykonujących wysiłek konieczne mogą być dłuższe przerwy.',
  plan_tts: 'TTS',
  plan_cns: 'CNS',
  plan_otu: 'OTU',
  plan_cns_series: 'CNS (dzień)',
  plan_otu_series: 'OTU (dzień)',
  plan_gas_requirements: 'Zapotrzebowanie na gaz bailout',
  plan_gas_consumption: 'Zużycie gazu',
  plan_liters: 'Litry',
  plan_type: 'Typ',
  plan_ppo2: 'ppO2',
  plan_density: 'Gęstość',
  plan_tissue: 'Tkanka',
  plan_flush: 'Płukania obiegu',
  plan_flush_hint: 'Zamierzone płukania obiegu podczas wynurzania, od najgłębszego do najpłytszego. Podczas płukania w obiegu znajduje się wskazany gaz pod ciśnieniem otoczenia, a nie setpoint.',
  plan_flush_add: 'Dodaj płukanie',
  plan_flush_none: 'Nie zaplanowano płukania',
  plan_flush_depth: 'Głębokość',
  plan_flush_gas: 'Płucz gazem',
  plan_flush_time: 'Czas trwania',
  plan_flush_keep: 'Zachowaj tę mieszaninę',
  plan_flush_keep_hint: 'Obieg pozostaje na wypłukanej mieszaninie aż do powierzchni, co odpowiada celowemu usunięciu helu przed dekompresją. Bez zaznaczenia wraca do używanego dilutentu: płukanie to czynność, a nie zmiana gazu.',
  plan_flush_remove: 'Usuń',
  plan_flush_figures: '{gas} na {depth} m: ppO2 {ppO2} bar, END {end} m, gęstość {density} g/L',
  plan_o2_flush_row: 'Zakończenie na tlenie: {time} min płukania na {depth} m, obieg pozostaje na tlenie do powierzchni.',
  plan_o2_flush_source: 'Ustawione w ustawieniach CCR, tutaj nie do zmiany.',
  plan_o2_flush_skipped_setting: 'Zakończenie na tlenie z ustawień ma nieużyteczną głębokość lub czas i nie zostaje zastosowane.',
  plan_o2_flush_skipped_clash: 'Zakończenie na tlenie z ustawień ustępuje na {depth} m: zaplanowano tam już Twoje własne płukanie.',
  plan_o2_flush_skipped_too_deep: 'Zakończenie na tlenie zaplanowane na {depth} m nie zostaje zastosowane: to nurkowanie nigdy nie schodzi poniżej {maxDepth} m.',
  plan_flush_helper: 'Oblicz',
  plan_flush_helper_title: 'Głębokość płukania',
  plan_flush_helper_hint: 'Podaj, co chcesz osiągnąć, a głębokość zostanie obliczona dla mieszaniny tego płukania oraz dla wody i wysokości miejsca nurkowania.',
  plan_flush_helper_mix: 'Mieszanina płukania',
  plan_flush_helper_target: 'Cel',
  plan_flush_target_ppo2: 'ppO2 (bar)',
  plan_flush_target_end: 'END (m)',
  plan_flush_helper_result: '{depth} m (dokładnie {exact} m)',
  plan_flush_helper_rounding: 'Zaokrąglone do płytszego metra, więc wartości poniżej są tymi z planu.',
  plan_flush_helper_apply: 'Użyj tej głębokości',
  plan_flush_helper_unreachable: 'Ta mieszanina nie daje tego na żadnej głębokości.',
  plan_flush_helper_deeper: 'Głębiej niż dno na {maxDepth} m: płukanie wykonuje się podczas wynurzania.',
  plan_flush_helper_no_nitrogen: 'Ta mieszanina nie zawiera azotu: jej END wynosi zero na każdej głębokości.',
  plan_flush_helper_band: 'Poza pasmem roboczym {min} - {max} bar.',
  plan_descent: 'Zanurzenie',
  plan_ascent: 'Wynurzenie',
  plan_bottom: 'Dno',
  plan_stop: 'Przystanek',
  plan_total_runtime: 'Całkowity runtime',
  plan_deco_time: 'Czas deko',
  plan_max_depth: 'Max głębokość',
  plan_bottom_time: 'Czas na dnie',
  plan_based_on_rmv: 'Na podstawie RMV',
  plan_insufficient_gas: 'Jedna lub więcej butli nie ma wystarczającej pojemności dla tego bailout!',
  plan_bars_needed: 'barów potrzebnych',

  // Profile
  profile_title: 'Profil nurkowania',
  profile_saturation: 'Nasycenie tkanek',
  profile_tap_details: 'Dotknij po szczegóły',
  profile_ceiling: 'Sufit',
  profile_surface: 'Powierzchnia',
  profile_residual: 'N2 resztkowy',
  profile_calculate_hint: 'Oblicz plan aby zobaczyć profil',
  profile_fullscreen: 'Pełny ekran',


  // Units
  unit_meters: 'm',
  unit_feet: 'ft',
  unit_minutes: 'min',
  unit_bar: 'bar',
  unit_psi: 'psi',
  unit_lpm: 'L/min',

  // Additional Plan
  plan_add_segment: 'Dodaj segment',
  plan_edit_segment: 'Edytuj segment',
  plan_diluent: 'Rozcieńczalnik',
  plan_dynamic_setpoint_info: 'Tryb dynamiczny aktywny',
  plan_override_setpoint: 'Wymuś stały setpoint (opcjonalnie)',
  plan_setpoint_auto: 'Auto',
  plan_mode: 'Tryb',
  plan_algorithm: 'Algorytm',
  plan_export_pdf: 'Eksportuj PDF',
  plan_save_html: 'Zapisz HTML',
  plan_calculate_first: 'Najpierw oblicz plan',
  plan_segment_for: '{depth}m przez {time} min',
  plan_gas_at_sp: '{gas} @ SP{sp}',
  plan_tank: 'Butla',
  plan_needed: 'Potrzebne',
  plan_status: 'Status',
  plan_insufficient: 'NIEWYSTARCZAJĄCY',
  plan_gas_tight: 'NA STYK',
  plan_ok: 'OK',
  plan_need_more: 'Brakuje {liters}L ({bars} bar)',
  plan_left: '{liters}L pozostało ({bars} bar)',
  plan_need_more_liters: 'Brakuje {liters}L',
  plan_left_liters: 'Pozostało {liters}L',
  plan_gas_unused: 'NIEUŻYWANY',
  plan_gas_unused_detail: '{liters}L zabrane, nigdy nieotwarte przez ten plan',
  plan_gas_backup: 'Zapas: {names}',

  // Gases additional
  gases_name_auto: 'Nazwa (auto jeśli puste)',
  gases_auto_label: 'Etykieta automatyczna',
  gases_n2_calc: 'N2 % (obliczone)',
  gases_end_at_mod: 'END @ MOD',
  gases_confirm_delete: 'Usunąć ten gaz?',
  gases_confirm_delete_diluent: 'Usunąć ten rozcieńczalnik?',
  gases_only_diluent: 'Nie można usunąć jedynego rozcieńczalnika',
  gases_form_invalid: 'Nieprawidłowe wartości: O2 powyżej 0 % i najwyżej 100 %, He od 0 % do poniżej 100 %, suma najwyżej 100 %; limit ppO2, pojemność i ciśnienie butli powyżej 0.',
  plan_segment_invalid: 'Podaj głębokość od 1 do 200 m, czas od 1 do 999 min i setpoint od 0,7 do 1,6 bar.',

  // Segment types
  segment_bail: 'BAIL',
  segment_desc: 'Zan',
  segment_asc: 'Wyn',
  segment_bottom: 'Dno',
  segment_stop: 'Przyst.',
  segment_gas_change: 'Zm. gazu',
  segment_diluent_change: 'Zm. dil.',
  segment_flush: 'Płukanie',
  segment_safety_stop: 'Bezp.',

  // Saved Plans
  nav_saved: 'Zapisane',
  saved_plans_title: 'Zapisane plany',
  saved_plans_save: 'Zapisz plan',
  saved_plans_saved: 'Plan zapisany!',
  saved_plans_empty: 'Brak zapisanych planów',
  saved_plans_empty_hint: 'Oblicz plan i zapisz go na później',
  saved_plans_load: 'Wczytaj',
  saved_plans_rename: 'Zmień nazwę',
  saved_plans_duplicate: 'Duplikuj',
  saved_plans_export: 'Eksportuj',
  saved_plans_confirm_delete: 'Usunąć ten plan?',
  saved_plans_import: 'Importuj',
  saved_plans_import_error: 'Błąd importu',
  saved_plans_name_label: 'Nazwa planu',
  saved_plans_name_placeholder: 'Wprowadź nazwę planu',
  plan_share: 'Udostępnij',
  feature_next_version: 'Dostępne w następnej wersji',

  // Dive environment carried by a plan: named in the exports and in the saved
  // plan list, and flagged when the plan on screen was computed for another one
  plan_environment_changed: 'Ten plan został obliczony dla innego rodzaju wody lub innej wysokości. Przelicz go ponownie przed nurkowaniem.',
  // Any other input the calculation reads (gradient factors, rates, ppO2
  // limits, gases, rebreather...) changed after the plan was computed
  plan_inputs_changed: 'Ten plan został obliczony z innymi parametrami nurkowania. Przelicz go ponownie przed nurkowaniem.',
  export_environment: 'Środowisko',
  saved_plan_environment: 'Środowisko',

  // PDF Export
  pdf_title: 'Plan nurkowania - mvplan',
  pdf_exporting: 'Generowanie PDF...',
  pdf_generated: 'Wygenerowano',
  pdf_mode_oc: 'Obieg otwarty',
  pdf_footer_generated: 'Wygenerowano przez mvplan - Planer nurkowań technicznych',
  pdf_footer_verify: 'Zawsze weryfikuj plan i noś tabele zapasowe',

  // PDF format choice
  pdf_choose_format: 'Format PDF',
  pdf_choose_format_hint: 'Wybierz dokument do eksportu',
  pdf_format_complete: 'Pełny',
  pdf_format_complete_hint: 'Szczegółowy raport wielostronicowy (tabele, profil, gaz)',
  pdf_format_condensed: 'Skrócony (1 strona)',
  pdf_format_condensed_hint: 'Karta planowania do wydruku na jednej stronie',

  // PDF condensed form
  pdf_form_title: 'Planowanie nurkowania',
  pdf_form_date: 'Data',
  pdf_form_team: 'Grupa nr',
  pdf_form_diver: 'Nurek',
  pdf_form_lastname: 'Imię, Nazwisko',
  pdf_form_machine: 'Aparat',
  pdf_form_gf: 'Grad. Fac.',
  pdf_form_runtime_title: 'Run Time',
  pdf_form_planned_depth: 'Planowana głębokość',
  pdf_form_planned_bottom: 'Planowany czas denny',
  pdf_form_palier: 'Głębokość przystanku',
  pdf_form_descent: 'Zanurzenie',
  pdf_form_bottom: 'Dno',
  pdf_form_duration: 'Czas',
  pdf_form_cumul: 'Suma',
  pdf_form_mutualized: 'Współdzielony',
  pdf_form_vol_liters: '% / Obj. w litrach',
  pdf_form_col_pct: '%',
  pdf_form_col_vol: 'Obj.',
  pdf_form_col_press: 'Ciśn.',
  pdf_form_col_liters: 'Lit.',
  pdf_form_yes: 'tak',
  pdf_form_no: 'nie',
  pdf_form_gas_switch_legend: 'zmiana gazu',
  pdf_form_gas_verdict_legend: "Pole Lit. nurka 1: zielony = OK, pomarańczowy = na styk, czerwony = za mało na wynurzenie na bailoucie, szary = nieużywany. Liczby w prawej kolumnie.",
  pdf_form_dtr: 'TTS',

  // Safety Alerts
  alerts_summary_title: 'Punkty wymagające uwagi w tym planie',
  alert_hypoxia: 'ppO2 {value} bar poniżej minimum 0.16 bar: ta mieszanina nie nadaje się do oddychania na tej głębokości. Zaplanuj gaz bogatszy w tlen.',
  alert_hyperoxia: 'ppO2 {value} bar powyżej maksimum 1.6 bar. Zmniejsz udział tlenu lub używaj tego gazu płycej.',
  alert_end_critical: 'END {value}m poza limitem 40m. Dodaj hel do mieszaniny dennej, aby zmniejszyć narkozę.',
  alert_end_high: 'END {value}m powyżej zalecanych 30m. Mieszanina bogatsza w hel zmniejsza narkozę.',
  alert_density_critical: 'Gęstość gazu {value} g/L powyżej zalecanych 6.2 g/L: oddychanie na tej głębokości może stać się trudne. Dodaj hel do mieszaniny dennej.',
  alert_density_high: 'Gęstość gazu {value} g/L powyżej 5.2 g/L zalecanych na rebreatherze. Ogranicz wysiłek lub wzbogać diluent w hel.',
  alert_narcosis_increase: 'ppN2 rośnie z {ccrValue} do {value} bar przy przejściu na bailout: narkoza silniejsza niż na rebreatherze. Bailout bogatszy w hel łagodzi przejście.',
  alert_end_increase: 'END rośnie z {ccrValue}m do {value}m przy przejściu na bailout. Bailout bogatszy w hel zmniejsza tę różnicę.',
  alert_icd_risk: 'Hel spada z {prevValue}% do {value}% przy tej zmianie gazu. Bardziej stopniowe przejście (mieszanina pośrednia) pozwala uniknąć izobarycznej kontrdyfuzji.',
  alert_ceiling_violation: 'Ten profil wynurza się do {depth}m, podczas gdy sufit deko jest na {ceiling}m. Pozostań poniżej sufitu i wydłuż przystanek przed wynurzeniem.',
  alert_stop_time_truncated: 'Przystanek na {depth}m ograniczony do {time} min: osiągnięto wewnętrzny limit obliczeń bez uwolnienia sufitu. Ten plan jest niekompletny, nie realizuj go - skróć czas denny, dodaj gaz dekompresyjny lub zwiększ GF górny.',
  alert_runtime_limit: 'Obliczenia przerwane na wewnętrznym limicie runtime {runtime} min: ten plan jest niekompletny, nie realizuj go - skróć nurkowanie lub dodaj bogatszy gaz dekompresyjny.',
  alert_entry_ceiling: 'Sufit na {ceiling}m na początku tego nurkowania, przy ustawionych tu współczynnikach gradientu: przerwa powierzchniowa {interval} min nie usuwa zobowiązań poprzedniego nurkowania, nurek jest winien przystanek jeszcze przed wejściem do wody. Ten plan nadrabia to podczas wynurzania - wydłuż przerwę przed nurkowaniem.',
  alert_residual_state_unloaded: 'Resztkowy stan tkanek bez jakiegokolwiek wysycenia: ma następować po nurkowaniu, a mimo to żaden kompartment nie jest powyżej poziomu spoczynkowego. Ten plan jest więc krótszy niż to samo nurkowanie liczone na czystych tkankach - nie nurkuj według niego, przelicz ponownie poprzednie nurkowanie.',
  alert_default_gas_fallback: 'Brak aktywnej mieszanki: ten plan został obliczony domyślnie na powietrzu. Nie odpowiada skonfigurowanym gazom - włącz co najmniej jedną mieszankę w widoku Gazy i przelicz plan ponownie przed nurkowaniem.',
  alert_gas_above_mod: 'Żaden zabrany gaz nie sięga {depth}m przy obowiązującym tam limicie ppO2 {limit} bar: ten plan każe oddychać tam mieszanką {gas}, poza jej MOD wynoszącą {mod}m przy tym limicie, przy ppO2 {ppO2} bar. To najuboższa mieszanka z twojej listy, wybrana domyślnie, a nie przez ciebie - zabierz mieszankę odpowiednią do tej głębokości albo podnieś limit przed nurkowaniem.',
  alert_gas_switch_on_empty: 'Butla z mieszanką {gas} pustoszeje na {depth}m: pokazana tam zmiana gazu nie jest zaplanowanym przez ciebie przełączeniem dekompresyjnym, tylko planem przechodzącym na to, co zostało. Zabierz więcej tej mieszanki albo zaplanuj własne przełączenie powyżej tej głębokości, zanim zanurkujesz.',
  alert_gas_exhausted: 'Wszystkie butle użyteczne na {depth}m są puste: od tego miejsca ten plan zaleca gaz, którego już nie masz. Zwiększ pojemność lub zabierz mieszankę sięgającą tej głębokości przed nurkowaniem.',
  alert_gas_insufficient: 'Butle z {gas} mieszczą {capacity} L, a ten plan zużywa {liters} L tej mieszanki: brakuje {missing} L. Zabierz jej więcej lub zaplanuj krótsze nurkowanie, zanim zanurkujesz.',
  alert_flush_not_reached: 'Płukanie obiegu zaplanowane na {depth}m nigdy nie nastąpi: końcowe wynurzenie zaczyna się na {ascentStart}m, powyżej. Przenieś płukanie płycej albo uczyń je ostatnim poziomem nurkowania.',
  alert_flush_ppo2: 'Płukanie na {depth}m gazem {gas} ustawia obieg na {ppO2} bar tlenu, poza Twoim zakresem roboczym {min} - {max} bar. Podczas płukania setpoint nie obowiązuje: w obiegu jest to, co daje ten gaz na tej głębokości.',
  alert_o2_flush_too_deep: 'Zakończenie na tlenie zaplanowane na {depth}m nigdy nie następuje: to nurkowanie nigdy nie schodzi poniżej {maxDepth}m, żadne wynurzanie nie przechodzi przez tę głębokość.',

  // Plan validation errors
  plan_error_title: 'Nie można obliczyć planu',
  plan_error_no_segments: 'Brak segmentu nurkowania: dodaj co najmniej jeden segment z głębokością i czasem.',
  plan_error_invalid_depth: 'Nieprawidłowa głębokość: podaj głębokość równą lub większą niż 0 m dla każdego segmentu (0 m to przerwa powierzchniowa).',
  plan_error_invalid_time: 'Nieprawidłowy czas: podaj czas równy lub dłuższy niż 0 min dla każdego segmentu.',
  plan_error_invalid_gf: 'Nieprawidłowe współczynniki gradientu: GF dolny musi być mniejszy lub równy GF górnemu, a oba większe od 0% i najwyżej 100%.',
  plan_error_invalid_gas: 'Nieprawidłowa mieszanka gazowa: udział O2 musi być większy od 0% i najwyżej 100%, udział He od 0% do poniżej 100%, a ich suma nie może przekraczać 100%.',
  plan_error_no_diluent: 'Brak prawidłowego rozcieńczalnika: wybierz rozcieńczalnik do nurkowania z rebreatherem w widoku Gazy.',
  plan_error_invalid_setpoint: 'Nieprawidłowy setpoint: podaj setpoint ppO2 w zakresie od 0.4 do 1.6 bar, granice włącznie.',
  plan_error_no_bailout_gas: 'Brak aktywnego gazu ratunkowego: włącz co najmniej jeden gaz bailout w widoku Gazy, aby obliczyć bailout.',
  plan_error_invalid_tissue_state: 'Nieprawidłowy stan resztkowy tkanek: nie udało się odczytać poprzedniego nurkowania z serii. Przelicz ponownie poprzednie nurkowanie przed zaplanowaniem tego.',
  plan_error_invalid_surface_interval: 'Nieprawidłowa przerwa powierzchniowa: podaj czas równy 0 min lub dłuższy między poprzednim nurkowaniem a tym.',
  plan_error_invalid_flush: 'Nieprawidłowe płukanie obiegu: nadaj każdemu płukaniu głębokość powyżej dna, czas trwania powyżej 0 min i tylko jedno płukanie na głębokość.',
  plan_error_time_shorter_than_descent: 'Czas segmentu krótszy niż jego zanurzanie: osiągnięcie {depth} m zajmuje {descentTime} min przy ustawionej prędkości zanurzania, a segment ma tylko {time} min. Czas zanurzania jest wliczony w czas segmentu (patrz ustawienia): podaj dłuższy czas lub wyłącz tę opcję.',
  plan_error_segment_gas_unavailable: 'Segment {index} ({depth} m) jest zaplanowany na {gas}, który jest wyłączony lub już nie istnieje. Włącz ten gaz w widoku Gazy lub wybierz inny dla segmentu.',
  plan_error_no_bailout_point: 'Plan rebreathera nie zawiera punktu bailoutu: nie został utworzony przez tę wersję planera. Oblicz ponownie plan rebreathera przed jego bailoutem.',
  plan_error_invalid_config: 'Nieprawidłowe ustawienie planera: prędkość wynurzania lub zanurzania, głębokość przystanku albo limit ppO2 jest poza zakresem. Sprawdź ustawienia planera przed obliczeniem.',

  // Dive Info
  plan_notes: 'Notatki',
  plan_notes_placeholder: 'Dodaj notatki do wydrukowanego planu (przypomnienia, instrukcje, itp.)',
  plan_divers_placeholder: 'Nurkowie na to nurkowanie',

  // App Store Links
  app_available_on: 'Dostępne na:',
  app_get_ios: 'Pobierz z App Store',
  app_get_android: 'Pobierz z Google Play',

  // Tissue compartment descriptions
  tissue_desc_1: 'Krew, rdzeń kręgowy',
  tissue_desc_2: 'Krew, mózg',
  tissue_desc_3: 'Mózg, tkanka nerwowa',
  tissue_desc_4: 'Dobrze ukrwione mięśnie',
  tissue_desc_5: 'Skóra, narządy wewnętrzne',
  tissue_desc_6: 'Mięśnie, narządy',
  tissue_desc_7: 'Mięśnie',
  tissue_desc_8: 'Mięśnie, więzadła',
  tissue_desc_9: 'Ścięgna, tkanka łączna',
  tissue_desc_10: 'Chrząstki',
  tissue_desc_11: 'Chrząstki, kości',
  tissue_desc_12: 'Kości, stawy',
  tissue_desc_13: 'Kości, tłuszcz',
  tissue_desc_14: 'Tkanka tłuszczowa',
  tissue_desc_15: 'Tłuszcz, szpik kostny',
  tissue_desc_16: 'Tłuszcz, szpik kostny',
  tissue_halftime: 'Czas półnasycenia',
  tissue_speed_fast: 'tkanka szybka',
  tissue_speed_medium: 'tkanka średnia',
  tissue_speed_slow: 'tkanka wolna',
  tissue_leading: 'Kompartment wiodący',
  tissue_leading_detail: '{tissue} (C{num}) wyznacza sufit na {ceiling}m - obciążenie {gf}% (GF {gfLow}/{gfHigh}, limit tutaj: {gfLimit}%)',
  tissue_leading_no_ceiling: '{tissue} (C{num}) jest najbardziej obciążony - obciążenie {gf}% (GF {gfLow}/{gfHigh}, limit tutaj: {gfLimit}%)',
  tissue_detail_title: 'Szczegóły kompartmentu',
  tissue_detail_coefficients: 'Współczynniki {algo}: a={a} (tolerancja na przesycenie), b={b} (czułość na głębokość). Stałe empiryczne Bühlmanna - szybkie tkanki (C1) tolerują więcej (a=1.17), wolne tkanki (C16) mniej (a=0.23).',
  tissue_detail_saturation: 'Saturacja',
  tissue_detail_gf_actual: 'Rzeczywisty GF',
  tissue_detail_no_supersaturation: 'Brak przesycenia',
  tissue_detail_undersaturated: 'Ten kompartment nie jest przesycony: ciśnienie tkankowe jest niższe od ciśnienia otoczenia. Pojęcie GF ma zastosowanie tylko przy przesyceniu (podczas wynurzania lub na przystanku dekompresyjnym).',
  tissue_detail_explanation: '{saturation}% saturacji nie oznacza {saturation}% GF. GF ({gfActual}%) mierzy wykorzystaną część marginesu między ciśnieniem otoczenia a M-value. Przy GF High {gfHigh}%, saturacja {saturation}% jest oczekiwana.',
  tissue_detail_explanation_gf_low: 'GF Low ({gfLow}%) określa głębokość pierwszego przystanku dekompresyjnego. Tutaj algorytm po raz pierwszy pozwala nurkowi zatrzymać się podczas wynurzania: wiodący kompartment wykorzystuje {gfUsed}% swojego marginesu między ciśnieniem otoczenia a M-value. Im niższy GF Low, tym głębiej zaczynają się przystanki.',
  tissue_detail_explanation_interpolated: 'Między pierwszym przystankiem a powierzchnią GF jest interpolowany liniowo od GF Low ({gfLow}%) do GF High ({gfHigh}%). Na tej głębokości zastosowany limit wynosi {gfUsed}%. Rzeczywisty GF tego kompartmentu wynosi {gfActual}%.',

  // Disclaimer
  disclaimer_title: 'Zastrzeżenie',
  disclaimer_text: 'To oprogramowanie jest jedynie pomocą w planowaniu nurkowania. Nie zastępuje szkolenia, doświadczenia ani oceny nurka. Autorzy nie ponoszą odpowiedzialności za wypadki lub incydenty. Zawsze weryfikuj plan innymi narzędziami i noś tabele zapasowe.',
  disclaimer_short: 'Tylko pomoc w planowaniu - nie zastępuje szkolenia ani oceny - brak odpowiedzialności',

  // Wsparcie projektu
  support_nav: 'Wesprzyj projekt',
  support_nav_website: 'Projekt',
  support_title: 'Wesprzyj MV-Plan',
  support_intro: 'MV-Plan to wolne oprogramowanie. Bez reklam, bez zakładania konta, bez zbierania danych, a wszystkie funkcje są dostępne dla każdego. To się nie zmieni.',
  support_costs_title: 'Ile kosztuje projekt',
  support_cost_apple: 'Konto deweloperskie Apple: 99 USD rocznie, nawet gdy aplikacja jest darmowa.',
  support_cost_google: 'Konto deweloperskie Google Play: 25 USD jednorazowo.',
  support_cost_domain: 'Domena i hosting strony mvplan.org.',
  support_cost_time: 'Czas poświęcony na rozwój, testy i dokumentację planera.',
  support_amount: 'Wystarczy kilka euro. Większość wpłat mieści się między 3 a 10 euro i to już bardzo pomaga.',
  support_nothing_unlocked: 'Wpłata niczego nie odblokowuje: nie ma wersji płatnej, ukrytych opcji ani listy darczyńców. Aplikacja pozostaje taka sama dla wszystkich.',
  support_thanks: 'Dziękuję wszystkim, którzy już wsparli projekt.',
  support_button: 'Wesprzyj',
  support_link_label: 'Adres strony',
  support_copy: 'Kopiuj odnośnik',
  support_copied: 'Odnośnik skopiowany',
  support_copy_failed: 'Nie udało się skopiować, zaznacz adres ręcznie',
  support_open_hint: 'Jeśli przycisk niczego nie otwiera, skopiuj powyższy adres do przeglądarki.',
  support_website_title: 'Projekt',
  support_website_intro: 'MV-Plan to wolne oprogramowanie tworzone w wolnym czasie autora. Na stronie projektu znajdziesz dokumentację, informacje o wydaniach i dane kontaktowe.',
  support_website_button: 'Otwórz stronę projektu'
}
